import Grid from '@material-ui/core/Grid';
import PageTitle from 'components/PageTitle';
import React from 'react';

export interface PageHeaderProps {
  title: string;
  subtitle?: string;
  rightSideComponent?: JSX.Element | JSX.Element[];
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  rightSideComponent,
}) => {
  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      justify="space-between"
      data-testid={'autosky-pageheader'}
    >
      <PageTitle title={title} subtitle={subtitle} />
      {!!rightSideComponent && rightSideComponent}
    </Grid>
  );
};

export default PageHeader;
